import { FeatureSwitches } from '../../../constants/feature-switches';
import { curbsidePickupButton, editDeliveryAddressButton, editDeliveryInstructionsButton, editPickupLocationButton, pickupLockerQRCodeButton, postRemorseCancelButton, remorseCancelButton, rescheduleDeliveryButton, returnsActions, startAReturnButton, editPickupPersonButton, trackDeliveryButton, bopisOutOfStock, } from './ActionButtonsLogic';
export var orderActionsButtonHandler = function (fulfillmentType, orderStatus, trackingUrl, buttonSettings) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var actionButtons = [];
    if (fulfillmentType === 'Unavailable' || fulfillmentType === undefined)
        return null;
    var recentlyOrdered = !((_a = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _a === void 0 ? void 0 : _a.isPostRemorseCancelEnabled) &&
        ((_b = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _b === void 0 ? void 0 : _b.isCancelEnabled);
    var estStartDeliveryDate = (_d = (_c = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentGroup) === null || _c === void 0 ? void 0 : _c.shippingAndHandling) === null || _d === void 0 ? void 0 : _d.estStartDeliveryDate;
    var after90Days = function (deliveryDate) {
        if (!deliveryDate)
            return false;
        return (new Date(deliveryDate) <= new Date(Date.now() - 90 * 24 * 60 * 60 * 1000));
    };
    if ((buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentTypeEligibleForReturn) &&
        ((_e = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _e === void 0 ? void 0 : _e.returnOnlineAllowed)) {
        actionButtons.unshift(startAReturnButton(buttonSettings, 'primary'));
    }
    if (orderStatus === 'Return Initiated' ||
        orderStatus === 'ReturnInProgress') {
        actionButtons.unshift(returnsActions(buttonSettings));
    }
    if (trackingUrl) {
        if ([
            'Delivered',
            'Return Initiated',
            'ReturnInProgress',
            'Being Processed',
        ].includes(orderStatus) ||
            ((buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentTypeEligibleForReturn) &&
                ((_f = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _f === void 0 ? void 0 : _f.returnOnlineAllowed)) ||
            after90Days(estStartDeliveryDate) ||
            ((_h = (_g = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentGroup) === null || _g === void 0 ? void 0 : _g.storePickup) === null || _h === void 0 ? void 0 : _h.isCurbsidePickupAvailable) ||
            ((_j = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _j === void 0 ? void 0 : _j.isPostRemorseCancelEnabled)) {
            actionButtons.push(trackDeliveryButton(trackingUrl, 'secondary'));
        }
        else {
            actionButtons.unshift(trackDeliveryButton(trackingUrl, 'primary'));
        }
    }
    if (recentlyOrdered) {
        actionButtons.unshift(remorseCancelButton(buttonSettings, 'primary'));
    }
    if ((((_k = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _k === void 0 ? void 0 : _k.reschedule) ||
        ((_l = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _l === void 0 ? void 0 : _l.isDFSRescheduleEnabled)) &&
        (buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.isRescheduleEligibleForMAorBODFSorDFS)) {
        actionButtons.push(rescheduleDeliveryButton(buttonSettings, 'secondary'));
    }
    if (((_m = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _m === void 0 ? void 0 : _m.isPostRemorseCancelEnabled) &&
        !(buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.cancellationRequested) &&
        ['ShipToHome', 'BuyOnlineShipToStore'].includes((_o = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentGroup) === null || _o === void 0 ? void 0 : _o.fulfillmentType) &&
        (buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.statusCode) !== 102) {
        if (fulfillmentType === 'BuyOnlinePickupInStore') {
            actionButtons.push(postRemorseCancelButton(buttonSettings, 'secondary'));
        }
        else {
            actionButtons.unshift(postRemorseCancelButton(buttonSettings, 'primary'));
        }
    }
    if (!FeatureSwitches.useTrackerAlignedUX &&
        ((_p = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _p === void 0 ? void 0 : _p.isEditPickupLocationEnabled)) {
        actionButtons.push(editPickupLocationButton(buttonSettings));
    }
    if ((_q = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _q === void 0 ? void 0 : _q.isEditDeliveryAddressEnabled) {
        actionButtons.push(editDeliveryAddressButton(buttonSettings));
    }
    if ((_r = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _r === void 0 ? void 0 : _r.isBopisOutOfStockEnabled) {
        actionButtons.push(bopisOutOfStock(buttonSettings));
    }
    if (!FeatureSwitches.useTrackerAlignedUX &&
        ((_s = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _s === void 0 ? void 0 : _s.isEditPickupPersonEnabled)) {
        actionButtons.push(editPickupPersonButton(buttonSettings));
    }
    if (!FeatureSwitches.useTrackerAlignedUX &&
        (((_t = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _t === void 0 ? void 0 : _t.isEditDeliveryInstructionsEnabled) ||
            ((_u = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.actions) === null || _u === void 0 ? void 0 : _u.isEditSiteInstructionsEnabled))) {
        actionButtons.push(editDeliveryInstructionsButton(buttonSettings, 'secondary'));
    }
    if ((_w = (_v = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentGroup) === null || _v === void 0 ? void 0 : _v.storePickup) === null || _w === void 0 ? void 0 : _w.isCurbsidePickupAvailable) {
        if ((_y = (_x = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentGroup) === null || _x === void 0 ? void 0 : _x.storePickup) === null || _y === void 0 ? void 0 : _y.IsInLocker) {
            actionButtons.push(curbsidePickupButton(buttonSettings));
        }
        else {
            actionButtons.unshift(curbsidePickupButton(buttonSettings));
        }
    }
    if ((_0 = (_z = buttonSettings === null || buttonSettings === void 0 ? void 0 : buttonSettings.fulfillmentGroup) === null || _z === void 0 ? void 0 : _z.storePickup) === null || _0 === void 0 ? void 0 : _0.IsInLocker) {
        actionButtons.unshift(pickupLockerQRCodeButton(buttonSettings));
    }
    return actionButtons;
};
